<template>
    <div align="center">
        <el-dialog title="提示" :visible.sync="dialogVisible" width="50%" :before-close="handleClose">
            <span>{{ msg }}</span>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
            </span>
        </el-dialog>
        <div v-if="bPrompt">

            <div align="center">
                <el-form :inline="true">
                    <el-form-item label="请输入昵称：">
                        <el-input v-model="nickname" placeholder="Enter your nickname"></el-input>
                    </el-form-item>
                    <el-button type="primary" @click="bPrompt = false; getRoomsInfo()">确 定</el-button>
                </el-form>
            </div>


        </div>
        <div align="center" v-else>
            <div v-if="bStart">
                <p>第{{ this.index + 1 }}题</p>
                <h1>{{ equastr }} <el-input v-model="answer" ref="answerInput"></el-input></h1>
                <div>
                    结果：
                </div>
                <div>
                    <el-button :disabled="prevStat" @click="prev">上一题</el-button>
                    <el-button :disabled="nextStat" @click="next" v-if="!nextStat" type="primary">下一题</el-button>
                    <el-button @click="finish" v-else type="primary">完成</el-button>
                    <span>时间：{{ usedtime }}</span>
                    <el-button @click="newGame()" v-show="bFinish" type="primary">再来一局</el-button>
                </div>
            </div>
            <div style="width: 80%" v-else>
                <span> 请选择练习的参数。
                </span><br><br><br>
                <el-form :inline="true">
                    <el-row>
                        <el-form-item label="选择：">
                            <el-checkbox-group v-model="checkList" :min="1">
                                <el-checkbox label="加法" :disabled="bSetting"></el-checkbox>
                                <el-checkbox label="减法" :disabled="bSetting"></el-checkbox>
                                <el-checkbox label="乘法" :disabled="bSetting"></el-checkbox>
                                <el-checkbox label="除法" :disabled="bSetting"></el-checkbox>
                            </el-checkbox-group>
                        </el-form-item>
                    </el-row>
                    <el-row>
                        <el-form-item label="位数：">
                            <el-input v-model="digit" :disabled="bSetting"></el-input>
                        </el-form-item>
                        <el-form-item label="数量：">
                            <el-input v-model="total" :disabled="bSetting"></el-input>
                        </el-form-item>
                    </el-row>

                </el-form>
                <table style="width:80%; text-align:center">
                    <tr>
                        <td width="50%">
                            <el-button @click="startGame()">开始对战</el-button>
                        </td>
                        <td width="50%">
                            <el-button @click="singleRound">单人练习</el-button>
                        </td>
                    </tr>
                </table>
            </div>

            <br>

            <div style="width: 80%; align: left">
                <table style="width:80%; text-align:center">
                    <tr><td colspan =4>Room:{{ this.roomInfo.roomName }} Name:{{ this.nickname }}</td></tr>
                    <tr>
                        <th width="20%">玩家</th>
                        <th width="10%">时间</th>
                        <th width="20%">状态</th>
                        <th width="50%">进度</th>
                    </tr>
                    <tr v-for="(player, index) in roomInfo.players" :key="player.nickname">
                        <td>{{ player.nickname }}</td>
                        <td>{{ uTime[index] }}</td>
                        <td>{{ player.status }}</td>
                        <td>
                            <el-progress :percentage="player.progress" :color="customColors"></el-progress>
                        </td>
                    </tr>
                </table>
                <br>
                <br>
            </div>

            <div id="roomsInfo" class="rooms-info-container">
                <div v-for="room in rooms" :key="room.roomName" style="margin-bottom: 10px;">
                    <el-badge :value="room.playerCount" class="item" :type="getBadgeType(room.playerCount)">
                        <el-button @click="handleRoomButtonClick(room)">
                            {{ room.roomName }}
                        </el-button>
                    </el-badge>
                    <!-- <span v-if="room.playerCount >= 2" style="color: red; margin-left: 10px;">房间已满</span> -->
                </div>
                <div>
                    <el-button @click="leaveRoom()">离开房间</el-button>
                </div>
            </div>

            <div>
                <el-form :inline="true">
                    <el-form-item label="房间名：">
                        <el-input v-model="roomName" placeholder="Enter room name"></el-input>
                    </el-form-item>
                    <el-button @click="createRoom()">创建房间</el-button>
                    <el-button @click="getRoomsInfo()">获取信息</el-button>
                </el-form>

            </div>

        </div>

    </div>
</template>

<script>
/*
function sleep(time) {
    return new Promise(resolve =>
        setTimeout(resolve, time)
    )
}
*/


import conf from "../config"


export default {
    name: "calcPractise",
    data() {
        return {
            "baseurl": conf.calcServer,
            equations: [],

            timer: null,
            starttime: 0,
            usedtime: 0.00,
            uTime: [0, 0],
            bPrompt: true,
            bStart: false,
            bFinish: false,
            bSetting: false,
            checkList: ["加法", "减法"],
            digit: 1,
            total: 10,
            equastr: "",
            answer: "",
            index: 0,
            prevStat: true,
            nextStat: false,

            customColors: [
                { color: '#f56c6c', percentage: 20 },
                { color: '#e6a23c', percentage: 40 },
                { color: '#5cb87a', percentage: 60 },
                { color: '#1989fa', percentage: 80 },
                { color: '#6f7ad3', percentage: 100 }
            ],
            percentage: 0,
            dialogVisible: false,
            msg: "成功完成。耗时：",
            tableWidth: '80%',
            tableHeight: "50%",
            fontSize: '',
            name: '',
            noResize: false,
            ws: {},
            roomInfo: {},
            rooms: [],
            nickname: '',
            roomName: '',

        }
    },
    mounted() {

        // const currentUrl = window.location.href;
        // const url = new URL(currentUrl);

        // 构建 WebSocket URL
        const websocketUrl = this.baseurl; // 假设 WebSocket 服务器的端口是 8080
        this.ws = new WebSocket(websocketUrl);
        this.ws.onmessage = (event) => {
            const data = JSON.parse(event.data);
            // const roomInfo = document.getElementById('roomInfo');
            switch (data.type) {
                case 'roomCreated':
                    // roomInfo.innerHTML = `Room created: ${data.roomName}`;
                    this.msg = `Room created: ${data.roomName}`;
                    this.$message.success(this.msg);
                    break;
                case 'roomJoined':
                    // roomInfo.innerHTML = `Joined room: ${data.roomName}`;
                    this.msg = `Joined room: ${data.roomName}`;
                    this.$message.success(this.msg)
                    break;
                case 'roomFull':
                    // roomInfo.innerHTML = 'Room is full';
                    this.msg = 'Room is full';
                    this.$message.error(this.msg);
                    break;
                case 'roomState':

                    this.roomInfo = data.roomState;
                    break;

                case 'gameStarted':
                    // console.log('gameStarted',JSON.stringify(data));
                    this.msg = 'Game started';
                    this.$message.success(this.msg);


                    this.starttime = Date.now();

                    this.init();
                    this.equations = data.equations;

                    // 更新题目表达式显示
                    this.equastr = this.generateEquationStr(this.index);
                    this.bStart = true;

                    // init()中增加了如下语句
                    // if (this.timer) {
                    //     clearInterval(this.timer);
                    // }
                    this.timer = setInterval(() => {
                        this.usedtime = ((Date.now() - this.starttime) / 1000).toFixed(2);
                        // this.uTime[0] = this.usedtime;
                        // this.uTime[1] = this.usedtime;

                    }, 100)
                    this.$nextTick(() => {
                        this.$refs.answerInput.focus();
                    });
                    break;
                case 'gameStartFailed':
                    // roomInfo.innerHTML = `Game start failed: ${data.message}`;
                    this.$message.error(`Game start failed: ${data.message}`)
                    break;
                case 'gameStartPending':
                    // roomInfo.innerHTML = `Game start pending: ${data.message}`;
                    this.$message.warn(`Game start pending: ${data.message}`);
                    break;
                case 'roomsInfo':
                    // this.displayRoomsInfo(data.roomsInfo);

                    this.rooms = data.roomsInfo;
                    console.log('roomsInfo', JSON.stringify(this.rooms))
                    break;
                case 'roomSetting':
                    // this.displayRoomsInfo(data.roomsInfo);
                    console.log('roomSetting', JSON.stringify(data))
                    this.checkList = data.roomSetting.operator;
                    this.total = data.roomSetting.num;
                    this.digit = data.roomSetting.digits;

                    if (this.roomInfo.players.some(player => player.status == 'ready')) {

                        this.bSetting = true;
                    }
                    break;
                case 'gameOver':
                    // roomInfo.innerHTML = `Game over: ${data.message}`;
                    // this.$message.info(`Game over: ${data.message}。用时：${this.usedtime}秒`);
                    clearInterval(this.timer);
                    this.timer = null;
                    {
                        const index = this.roomInfo.players.findIndex(player => player.status === "lose" || player.status === "finish");
                        this.uTime[index] = this.usedtime;
                    }
                    this.bFinish = true;
                    break;
                case 'gameWin':
                    // roomInfo.innerHTML = `Game over: ${data.message}`;
                    this.$message.success(`Game Win: ${data.message}。`);
                    {
                        const index = this.roomInfo.players.findIndex(player => player.nickname === data.winer);
                        this.uTime[index] = this.usedtime;
                    }


                    break;
                case 'gameLose':
                    // roomInfo.innerHTML = `Game over: ${data.message}`;
                    this.$message.error(`Game Lose: ${data.message}。`);
                    {
                        const index = this.roomInfo.players.findIndex(player => player.nickname === data.winer);
                        this.uTime[index] = this.usedtime;
                    }

                    break;
                default:
                    break;
            }
        };
        // this.getRoomsInfo()
    },
    beforeDestroy() {
        clearInterval(this.timer);
        this.ws.close();
        this.timer = null;
    },
    methods: {
        init() {
            this.equations = [];
            this.answer = ""
            this.index = 0;
            this.percentage = 0;
            this.usedtime = 0;
            this.uTime[0] = 0;
            this.uTime[1] = 0;
            this.nextStat = false;
            this.prevStat = true;
            if (this.timer) {
                clearInterval(this.timer);
            }
        },
        singleRound() {
            this.roomInfo.roomName = 'practiseRoom';
            const player = { nickname: this.nickname, status: 'start', progress: 0 };
            this.roomInfo.players = [player];
            // this.roomInfo.players.push(player);
            let setting = { digits: this.digit, operator: this.checkList, num: this.total };
            this.ws.send(JSON.stringify({ type: 'singleRound', setting: setting }))

            this.starttime = Date.now();
            this.percentage = 0;
            this.usedtime = 0;
            if (this.timer) {
                clearInterval(this.timer);
            }
            this.timer = setInterval(() => {
                this.usedtime = ((Date.now() - this.starttime) / 1000).toFixed(2);
                this.uTime[0] = this.usedtime;
            }, 100)
        },

        customColorMethod(percentage) {
            if (percentage < 30) {
                return '#909399';
            } else if (percentage < 70) {
                return '#e6a23c';
            } else {
                return '#67c23a';
            }
        },

        handleClose() {

        },
        generateEquationStr(index) {

            const eq = this.equations[index];
            if (!eq) return '';

            const { num1, num2, operator } = eq;
            let oper = '';
            switch (operator) {
                case "加法":
                    oper = ' + ';
                    break;
                case "减法":
                    oper = ' - ';
                    break;
                case "乘法":
                    oper = ' × ';
                    break;
                case "除法":
                    oper = ' ÷ ';
                    break;
                default:
            }
            return `${num1} ${oper || ''} ${num2} = `;
        },
        sendRoomState() {
            //更新游戏房间信息roomInfo
            if (this.roomInfo.roomName) {
                const player = this.roomInfo.players.find(p => p.nickname === this.nickname);
                if (player) {
                    player.progress = this.percentage;

                }
                if (this.roomInfo.roomName === "practiseRoom") {
                    if (this.percentage === 100) {
                        player.status = 'finish';
                        this.bFinish = true;
                        this.uTime[0] = this.usedtime;
                        clearInterval(this.timer);
                        this.timer = null;
                    }
                    

                } else if (player.status === 'start' || player.status === 'lose') {
                    let roomState = {
                        "roomName": this.roomInfo.roomName,
                        "nickname": player.nickname,
                        "status": player.status,
                        "progress": player.progress
                    }
                    this.updateGameProgress(roomState)
                }

            }
        },
        prev() {
            // 将当前答案保存到当前题目中
            this.equations[this.index].myAnswer = parseInt(this.answer);

            // 判断当前题目的答案是否正确
            // if (this.equations[this.index].myAnswer === this.equations[this.index].result) {
            //     this.equations[this.index].status = 'correct';
            // } else {
            //     this.equations[this.index].status = 'wrong';
            // }

            // 切换至上一题
            this.index--;
            this.percentage = Math.floor(this.index * 100 / (this.equations.length + 1));
            this.sendRoomState();

            // 更新题目表达式显示
            this.equastr = this.generateEquationStr(this.index);

            // 更新输入框为当前题目的答案（如果有）
            this.answer = this.equations[this.index].myAnswer || '';

            // 更新按钮状态
            this.prevStat = this.index === 0;
            this.nextStat = false;
            // 设置焦点到 answer 输入框
            this.$nextTick(() => {
                this.$refs.answerInput.focus();
            });
        },

        next() {
            // 将当前答案保存到当前题目中
            this.equations[this.index].myAnswer = parseInt(this.answer);
            this.index++;
            this.percentage = Math.floor(this.index * 100 / (this.equations.length + 1));
            this.sendRoomState();
            // 判断当前题目的答案是否正确
            // if (this.equations[this.index].myAnswer === this.equations[this.index].result) {
            //     this.equations[this.index].status = 'correct';
            // } else {
            //     this.equations[this.index].status = 'wrong';
            // }




            // 如果还有题目，则更新表达式和按钮状态
            if (this.index < this.equations.length) {
                // 切换至下一题


                this.equastr = this.generateEquationStr(this.index);
                this.answer = this.equations[this.index].myAnswer || '';
                this.prevStat = false;
                this.nextStat = this.index === this.equations.length - 1;
            } else {
                // 所有题目完成
                this.equastr = '已完成所有题目！';
                this.answer = '';
                this.prevStat = false;
                this.nextStat = true;
            }
            // 设置焦点到 answer 输入框
            this.$nextTick(() => {
                this.$refs.answerInput.focus();
            });
        },
        finish() {
            // 将当前答案保存到当前题目中
            this.equations[this.index].myAnswer = parseInt(this.answer) || 0;
            // 遍历所有题目，检查是否全部有答案且正确
            const allAnswered = this.equations.every(eq => eq.myAnswer !== undefined);
            const allCorrect = this.equations.every(eq => eq.myAnswer === eq.result);

            if (allAnswered && allCorrect) {
                // 所有题目完成且答案正确
                this.percentage = 100;
                this.roomInfo.status = 'finished';
                this.sendRoomState();

                this.$message.success('所有题目已完成且答案正确！');
            } else {
                let errorMsg = '';
                let unFinishedCount = 0;
                let wrongCount = 0;

                this.equations.forEach(eq => {
                    if (eq.myAnswer === undefined) {
                        unFinishedCount++;
                    } else if (eq.myAnswer !== eq.result) {
                        wrongCount++;
                    }
                });

                if (unFinishedCount > 0) {
                    errorMsg += `还有 ${unFinishedCount} 道题未作答；`;
                }

                if (wrongCount > 0) {
                    errorMsg += `有 ${wrongCount} 道题回答错误。`;
                }

                this.$message.error(errorMsg || '存在未完成或错误的答案，请检查后再提交');
            }
        },
        createRoom() {
            this.init();
            const nickname = this.nickname;
            const roomName = this.roomName;
            this.ws.send(JSON.stringify({ type: 'createRoom', nickname, roomName }));
        },

        joinRoom() {
            const nickname = this.nickname;
            const roomName = this.roomName;
            this.init();
            this.ws.send(JSON.stringify({ type: 'joinRoom', nickname, roomName }));
        },

        leaveRoom() {
            this.init();
            this.ws.send(JSON.stringify({ type: 'leaveRoom' }));
            this.bStart = false;
        },

        startGame() {
            this.init();
            if (this.roomInfo.roomName && this.roomInfo.roomName.length > 0) {
                let setting = { digits: this.digit, operator: this.checkList, num: this.total };
                this.ws.send(JSON.stringify({ type: 'startGame', setting }));
                this.bSetting = true;
            } else {
                this.$message({
                    message: '请先创建或加入房间',
                    type: 'warning'
                });
            }

        },

        newGame() {
            this.init();
            this.bStart = false;
            this.bFinish = false;
            this.bSetting = false;
            const player = this.roomInfo.players.find(p => p.nickname === this.nickname)
            player.status = 'idle';
            player.progress = 0;
            if(this.roomInfo.roomName!=='practiseRoom'){
                let roomState = {
                "roomName": this.roomInfo.roomName,
                "nickname": player.nickname,
                "status": player.status,
                "progress": player.progress
            }
            this.updateGameProgress(roomState)
            }
            



        },

        getRoomsInfo() {
            this.ws.send(JSON.stringify({ type: 'getRoomsInfo' }));
        },

        displayRoomsInfo(roomsInfo) {
            const roomsInfoDiv = document.getElementById('roomsInfo');
            roomsInfoDiv.innerHTML = '<h2>Rooms Info</h2>';
            roomsInfo.forEach(room => {
                const roomDiv = document.createElement('div');
                roomDiv.textContent = `Room: ${room.roomName}, Players: ${room.playerCount}`;
                roomsInfoDiv.appendChild(roomDiv);
            });
        },

        updateGameProgress(roomState) {
            this.ws.send(JSON.stringify({ type: 'gameProgress', roomState }));
        },
        handleRoomButtonClick(room) {
            if (room.playerCount < 2) {
                this.ws.send(JSON.stringify({ type: 'joinRoom', nickname: this.nickname, roomName: room.roomName }));
            } else {
                this.$message.error('房间已满');
            }
        },
        getBadgeType(playerCount) {
            if (playerCount === 0) {
                return 'primary'; // 蓝色
            } else if (playerCount === 1) {
                return 'success'; // 绿色
            } else {
                return 'danger'; // 红色
            }
        },
    },
    computed: {
    }
}
</script>

<style scoped>
.notice {
    alignment: center;
    border: 1px solid #2c3e50;
}

.notice td {
    border-width: 1px;
    padding: 8px;
    border-style: solid;
    border-color: #666666;
    text-align: center;
}

.default td {
    background: #42b983;
}

.ok td {
    background: chartreuse;
}

.wrong td {
    background: coral;
}

.promp {
    font-size: 20px;

}

.rooms-info-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    width: 80%;
    margin: 0 auto;
}

.rooms-info-container .item {
    margin: 5px;
}

.item {
    margin-top: 10px;
    margin-right: 30px;
}
</style>